import { createModel } from '@rematch/core';
import { RecordModel, RecordIDModel } from '@equifinance/shared';
import { RootModel } from '.';

const fields = [
  'accountId',
  'chatId',
  'title',
  'description',
  'status',
  'notes',
] as const;
export type Document = RecordIDModel<typeof fields[number]>;

const documentsModel = createModel<RootModel>()({
  ...RecordModel<Document>(fields),
});

export default documentsModel;
